var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "#00397D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.092 137.341H161.619V90.9298C161.492 87.9334 160.212 85.1018 158.047 83.0264C155.882 80.9511 152.999 79.7925 150 79.7925C147.001 79.7925 144.118 80.9511 141.953 83.0264C139.788 85.1018 138.508 87.9334 138.382 90.9298V137.404H91.9075C88.9111 137.53 86.0798 138.81 84.0045 140.975C81.9292 143.14 80.7705 146.023 80.7705 149.022C80.7705 152.021 81.9292 154.904 84.0045 157.069C86.0798 159.234 88.9111 160.514 91.9075 160.641H138.382V207.114C138.315 208.681 138.567 210.246 139.121 211.713C139.675 213.181 140.52 214.521 141.605 215.653C142.69 216.785 143.994 217.687 145.436 218.302C146.879 218.918 148.432 219.235 150 219.235C151.569 219.235 153.121 218.918 154.563 218.302C156.006 217.687 157.309 216.785 158.395 215.653C159.48 214.521 160.325 213.181 160.879 211.713C161.433 210.246 161.685 208.681 161.619 207.114V160.641H208.092C211.089 160.514 213.92 159.234 215.995 157.069C218.071 154.904 219.229 152.021 219.229 149.022C219.229 146.023 218.071 143.14 215.995 140.975C213.92 138.81 211.089 137.53 208.092 137.404V137.341Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillAdd);
export default __webpack_public_path__ + "static/media/fill-add.4816449e5c129dce016d45f8114e122a.svg";
export { ForwardRef as ReactComponent };